import { memo, useCallback, useEffect, useState } from "react";
import { Button } from "ui/components/Button/Button";
import { TextField } from "ui/components/TextField/TextField";
import { NumberField } from "ui/components/TextField/NumberField";
import { DatePicker } from "ui/components/DatePicker";
import { OfferSaleStatusDropdown } from "ui/components/Dropdown/OfferSaleStatusDropdown";
import { VehicleOfferSaleSearchFilterProps } from "./types";
import { useTranslate } from "helpers";
import { FleetVehicleOfferSaleSearchFormValues } from "services/api/fleet/vehicles/offers/types";
import { initialFleetVehicleOfferSaleSearchForm } from "services/api/fleet/vehicles/offers/consts";
import {
  useHandleTextFieldChange,
  useHandleDropdownChange,
  useHandleDateChange,
  useHandleNumberFieldChange,
} from "services/forms/hooks";

const VehicleOfferSaleSearchFilters: React.FC<VehicleOfferSaleSearchFilterProps> = (props) => {
  const { onAddNew, onSearchChange } = props;
  const { t } = useTranslate();

  const [formValues, setFormValues] = useState<FleetVehicleOfferSaleSearchFormValues>(
    initialFleetVehicleOfferSaleSearchForm
  );
  useEffect(() => {
    onSearchChange(formValues);
  }, [formValues]);

  const handleTextFieldChange = useHandleTextFieldChange(setFormValues, formValues);
  const handleDropdownChange = useHandleDropdownChange(setFormValues, formValues);
  const handleDateChange = useHandleDateChange(setFormValues, formValues);
  const handleNumberFieldChange = useHandleNumberFieldChange(setFormValues, formValues);

  const handleResetFormClick = useCallback(() => {
    setFormValues(initialFleetVehicleOfferSaleSearchForm);
  }, []);

  return (
    <div className="flex flex-wrap items-end gap-2 mb-3">
      <div className="w-[150px]">
        <TextField
          type="text"
          name="search"
          value={formValues.search}
          onChange={handleTextFieldChange}
          placeholder="Pretraži..."
          startIcon="/media/icons/search.svg"
          cssClassName="bg-white"
        />
      </div>
      <div className="w-[150px]">
        <OfferSaleStatusDropdown
          name="offerSaleStatusId"
          value={formValues.offerSaleStatusId}
          onChange={handleDropdownChange}
          placeholder="Status"
          width="full"
        />
      </div>
      <div className="w-[120px]">
        <DatePicker
          name="offerDateFrom"
          label="Ponuda od - do"
          value={formValues.offerDateFrom}
          onChange={handleDateChange}
          cssClassName="bg-white"
        />
      </div>
      <div className="w-[120px]">
        <DatePicker
          name="offerDateTo"

          value={formValues.offerDateTo}
          onChange={handleDateChange}
          cssClassName="bg-white"
        />
      </div>
      <div className="w-[120px]">
        <DatePicker
          name="dueDateFrom"
          label="Dospijeće od - do"

          value={formValues.dueDateFrom}
          onChange={handleDateChange}
          cssClassName="bg-white"
        />
      </div>
      <div className="w-[120px]">
        <DatePicker
          name="dueDateTo"

          value={formValues.dueDateTo}
          onChange={handleDateChange}
          cssClassName="bg-white"
        />
      </div>
      <div className="w-[90px]">
        <NumberField
          name="totalMin"
          label="Cijena od - do"
          placeholder="Cijena od"
          value={formValues.totalMin}
          onChange={handleNumberFieldChange}
          decimals={2}
          cssClassName="bg-white"
        />
      </div>
      <div className="w-[90px]">
        <NumberField
          name="totalMax"
          placeholder="do"
          value={formValues.totalMax}
          onChange={handleNumberFieldChange}
          decimals={2}
          cssClassName="bg-white"
        />
      </div>
      <span
        onClick={handleResetFormClick}
        className="text-xs font-bold cursor-pointer text-gray-500 hover:text-sky-600 pb-2 whitespace-nowrap"
      >
        RESET
      </span>
      <div className="ml-auto">
        <Button
          variant="primary"
    
          children={t("admin.vehicle.offersale.search.add")}
          startIcon="/media/icons/plus.svg"
          onClick={onAddNew}
        />
      </div>
    </div>
  );
};

export default memo(VehicleOfferSaleSearchFilters);
